var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyChooseIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_141530",
    "data-name": "Group 141530",
    width: 22.182,
    height: 23.66,
    viewBox: "0 0 22.182 23.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_119182",
    "data-name": "Path 119182",
    d: "M36.818,3.875,27.946.178a2.212,2.212,0,0,0-1.705,0l-8.872,3.7A2.2,2.2,0,0,0,16,5.88c0,11.936,8.753,17.787,11.086,17.787,2.278,0,11.1-5.763,11.1-17.787A2.2,2.2,0,0,0,36.818,3.875Z",
    transform: "translate(-16 -0.007)",
    fill: "#073c00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119183",
    "data-name": "Path 119183",
    d: "M30.566,8.6a.7.7,0,0,0-.5.206L25.874,13l-1.847-1.847a.685.685,0,0,0-.5-.207.7.7,0,0,0-.5,1.2L25.378,14.5a.719.719,0,0,0,.5.2.708.708,0,0,0,.5-.206L31.063,9.8a.7.7,0,0,0-.5-1.2Z",
    transform: "translate(-15.653 -0.397)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseIcon2);
export default __webpack_public_path__ + "static/media/whyChoose-icon2.28206fe911213ddac896cc87844ec8bf.svg";
export { ForwardRef as ReactComponent };